import {
  detachLayoutProps,
  WSDivider,
  WSElement,
  WSList,
  WSMarginProps,
  WSSectionToolbar
} from "@wingspanhq/fe-component-library";
import { ValidationItem } from "./ValidationItem";
import { RequirementContextType } from "../../types";
import { ISharedFileRequestJobResponse } from "@wingspanhq/shared-files/dist/lib/interfaces/api/sharedFileRequestJob";
import { ISharedFileRequestSettingsJob } from "@wingspanhq/shared-files/dist/lib/interfaces";

type Props = {
  validationItems:
    | ISharedFileRequestJobResponse[]
    | ISharedFileRequestSettingsJob[];
  contextType: RequirementContextType;
  optionalValidationItems?:
    | ISharedFileRequestJobResponse[]
    | ISharedFileRequestSettingsJob[];
  hideTitle?: boolean;
} & WSMarginProps;

export const AIValidationWidget: React.FC<Props> = ({
  validationItems,
  contextType,
  optionalValidationItems,
  hideTitle,
  ...other
}) => {
  const { layoutProps } = detachLayoutProps(other);
  return (
    <WSElement {...layoutProps}>
      <WSList gap="M">
        {!hideTitle && <WSSectionToolbar title="Validations" />}
        {optionalValidationItems &&
          optionalValidationItems.length > 0 &&
          optionalValidationItems.map((item, index) => (
            <ValidationItem
              key={item.title + index}
              contextType={contextType}
              item={item}
            />
          ))}
        {optionalValidationItems && optionalValidationItems.length > 0 && (
          <WSDivider label="OR" />
        )}
        {validationItems.map((item, index) => (
          <ValidationItem
            key={item.title + index}
            contextType={contextType}
            item={item}
          />
        ))}
      </WSList>
    </WSElement>
  );
};
